import React from 'react'
import { Row, Col } from 'react-bootstrap'
import i18next from 'i18next'
import GridContainer from './GridContainer'
import Error from './smart/ErrorContainer'
import Loading from './Loading'

import supportService from '../services/support'
import { availableLanguages } from './../assets/translations/availableLanguages'

import illustration from '../assets/images/wopi-clipped-puzzle.png'
import document from '../assets/images/document.svg'

import adminStyles from './styles/admin.scss'
import supportStyles from './styles/support.scss'

const materials = [
  {
    title: 'quick_reference',
    filename: 'wopi-quick-reference.pdf'
  },
  {
    title: 'analysis_page',
    filename: 'wopi-profile-analysis.pdf'
  },
  {
    title: 'analysis_page_and_work_wellbeing',
    filename: 'wopi-profile-analysis-and-work-wellbeing.pdf'
  },
  {
    title: 'dimension_specs',
    filename: 'wopi-dimension-specs.pdf'
  },
  {
    title: 'key_slides',
    filename: 'wopi-keyslides.ppt'
  },
  {
    title: 'example_questions',
    filename: 'wopi-example-questions.pdf'
  },
  {
    title: 'wopi_extra_profiles',
    filename: 'wopi-extra-profiles.pdf'
  },
  {
    title: 'wopi_extra_profiles_and_work_wellbeing',
    filename: 'wopi-extra-profiles-and-work-wellbeing.pdf'
  },
  {
    title: 'leadership_roles_self_evaluation',
    filename: 'wopi-leadership-roles-self-evaluation.pdf'
  },
  {
    title: 'group_basics',
    filename: 'wopi-group-basics.pdf'
  }
]

export default class SupportPage extends React.Component {
  constructor(props) {
    super(props)

    i18next.loadLanguages(props.language, () => {
      this.state = {
        language: props.language,
        availableFiles: [],
        isLoading: false
      }
    })
  }

  componentDidMount() {
    this.loadAvailableFiles(this.props.language)
  }

  loadAvailableFiles = language => {
    this.setState({ isLoading: true })

    supportService
      .getAvailableFiles(language)
      .then(x => {
        this.setState({ availableFiles: x.data, isLoading: false })
      })
      .catch(err => {
        this.setState({ isLoading: false })
        this.props.setError('support_page_error')
      })
  }

  changeLanguage = language => {
    this.setState({ language })
    this.loadAvailableFiles(language)
  }

  renderLoading = () => {
    return <Loading inline />
  }

  renderMaterials = () => {
    return (
      <Col sm={9}>
        <Row>
          <Col sm={12} className={supportStyles.materialList}>
            {materials
              .filter(material => this.state.availableFiles.includes(material.filename))
              .map((material, key) => (
                <Col sm={6} md={6} lg={4} key={key}>
                  <a
                    href={`/api/support/download/${this.state.language}/${material.filename}`}
                    className={supportStyles.material}
                  >
                    <div>
                      <img src={document} />

                      <h3>{i18next.t(`${material.title}_description`, { lng: this.state.language })}</h3>

                    </div>
                  </a>
                </Col>
              ))}
          </Col>
        </Row>
      </Col>
    )
  }

  render() {
    if (this.props.hasError) {
      return (
        <GridContainer>
          <Error />
        </GridContainer>
      )
    }

    return (
      <GridContainer>
        <Row>
          <Col md={12}>
            <div className={adminStyles.customerService}>
              <Row>
                <Col sm={8}>
                  <div style={{ padding: '0 20px' }}>
                    <h1>{i18next.t('customer_service')}</h1>

                    <p>{i18next.t('customer_service_description')}</p>

                    <br />

                    <h3>{i18next.t('customer_service_number_text')}</h3>
                    <h3>{i18next.t('customer_service_email_text')}</h3>
                  </div>
                </Col>

                <Col sm={4} style={{ textAlign: 'right' }}>
                  <img src={illustration} />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <div>
          <Row>
            <Col sm={3} className={supportStyles.languages}>
              <ul>
                {availableLanguages.map(l => (
                  <li
                    key={l.key}
                    className={l.key === this.state.language && supportStyles.selected}
                  >
                    <a
                      href="#"
                      onClick={e => {
                        e.preventDefault()
                        i18next.loadLanguages(l.key, () => this.changeLanguage(l.key))
                      }}
                    >
                      {i18next.t(l.translationKey)}
                    </a>
                  </li>
                ))}
              </ul>
            </Col>
            {this.state.isLoading ? this.renderLoading() : this.renderMaterials()}
          </Row>
        </div>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SupportPage.js